import { EWorkshopPartType } from 'data/types/workshopTasks.types';
import { TWorkshopDetailsDataUI } from 'data/types/workshops.types';
import { SECTION_LABEL, SECTION_ORDER } from '../sortTasksByPart';

// Part choices for a custom task (GROW-4215): Prep and Post are logical phases
// every workshop has; session parts are offered only if this workshop actually
// has them (a standalone workshop shows "Session", a 3-part series shows 1/2/3).
export const getCustomTaskPartOptions = (
  parts: TWorkshopDetailsDataUI['parts'] | undefined,
) => {
  const sessionParts = new Set<string>(
    (parts ?? []).map(part => String(part.partType)),
  );
  return SECTION_ORDER.filter(
    part =>
      part === EWorkshopPartType.PREP ||
      part === EWorkshopPartType.POST ||
      sessionParts.has(part),
  ).map(part => ({ label: SECTION_LABEL[part], value: part }));
};
